import React, { Component } from 'react';
import styles from './permissions.module.scss';
import classnames from 'classnames';
import { strings } from '../../components/utils/translations';
import API from '../../components/utils/API';
import CloseIcon from '../../img/icons/closeIcon';
import { Form, Radio, Button, Switch, TimePicker, DatePicker } from 'antd';
import PrimaryButton from '../../components/Buttons/primaryButton';
import Counter from '../../components/Counter/counter';
import UnlimitedIcon from '../../img/icons/unlimited-icon.svg';
import TemporalIcon from '../../img/icons/clock-icon.svg';
import RecurrentIcon from '../../img/icons/recurrent-icon.svg';
import DownOutlinedIcon from '../../img/icons/downOutlined-icon.svg';
import ProgressSteps from '../../components/ProgressSteps/progressSteps'
import { notification } from 'antd'
import HouseSubscriptionsView from '../../components/HouseSubscriptionsView/HouseSubscriptionsView'

import moment from "moment";
const { RangePicker } = DatePicker;
const timeFormat = 'HH:mm';
const dateFormat = 'YYYY/MM/DD'
const dateDisplayFormat = 'DD MMM YYYY'
const dateTimeDisplayFormat = 'DD/MM/YYYY HH:mm'

export default class SelectAccessTypePermissions extends Component
{
	constructor(props)
	{
		super(props);

		this.state =
		{
            closePermissions: props.closePermissions,
            accessType: [],
            validation: {
                state: '',
                message: ''
            },
            validationDays: {
                state: '',
                message: ''
            },
            permissionFrequency: 'unlimited',
            permission: {
                roleType: 'owner',
                permissionsToGrant: 0,
            },
            modal: {
                endDateOpen: false,
                disabledEndHours: null,
                disabledEndMinutes: null,
                disabledStartHours: null,
                disabledStartMinutes: null,
                selectedDay: {
                    value: null,
                    name: null
                },
                markedDays: {
                    1: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    2: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    3: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    4: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    5: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    6: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    },
                    0: {
                        set: false,
                        selected: false,
                        allDay: false,
                        startTime: null,
                        endTime: null
                    }
                }
            },
			
			minPermissionType: null,
			selectedSubscription: null
		}
		
		this.daysOfTheWeek = [
            {
                value: 1,
                shortName: strings('mondayShort'),
                longName: strings('monday')
            },
            {
                value: 2,
                shortName: strings('tuesdayShort'),
                longName: strings('tuesday')
            },
            {
                value: 3,
                shortName: strings('wednesdayShort'),
                longName: strings('wednesday')
            },
            {
                value: 4,
                shortName: strings('thursdayShort'),
                longName: strings('thursday')
            },
            {
                value: 5,
                shortName: strings('fridayShort'),
                longName: strings('friday')
            },
            {
                value: 6,
                shortName: strings('saturdayShort'),
                longName: strings('saturday')
            },
            {
                value: 0,
                shortName: strings('sundayShort'),
                longName: strings('sunday')
            }
        ]
	}

    componentDidMount()
	{
        this.componentWillReceiveProps(this.props)
    }

    componentWillReceiveProps(props)
    {
        this.props.permissions.map((permission) =>
        {
            permission.data.map((permission) =>
            {
                if (permission != null && JSON.stringify(permission).length > 2)
                {
                    if (this.originalPermission == null)
                        this.originalPermission = Object.assign({}, permission)

                    this.setStateFromOriginalPermission(permission)
                }
            })
        })
		
		this.setMinPermissionType()
    }

    setStateFromOriginalPermission(originalPermission)
    {
        let modal = this.state.modal
        let permissionFrequency

        this.setState({
            permission: {},
            permissionFrequency: null,
        }, () =>
        {
            let permission = Object.assign({}, originalPermission)

            if (permission.PermissionDays && permission.PermissionDays.length)
            {
                permissionFrequency = 'recurrent'

                permission.PermissionDays.forEach(item =>
                {
                    modal.markedDays[item.dayOfWeek].set = true

                    if (item.endTime && item.startTime)
                    {
                        modal.markedDays[item.dayOfWeek].startTime = item.startTime
                        modal.markedDays[item.dayOfWeek].endTime = item.endTime
                    }
                    else
                    {
                        modal.markedDays[item.dayOfWeek].allDay = true
                    }
                })
            }
            else if (permission.startDate)
                permissionFrequency = 'temporary'
            else if (permission.roleType)
                permissionFrequency = 'unlimited'

            this.setState({
                permission,
                permissionFrequency,
                modal
            })
        })
    }

	render()
	{
		let numRemotesNeeded = this.getNumRemotesNeeded()
		
		return (
            <div className={classnames(styles.selectDoorsContainer, styles.accessType)}>
                <div className="responsive-container">
                    <div className={styles.permissionsTopBar}>
                        <div>
                            <ProgressSteps
								activeStepIndex={2}
								numDoors={this.props.selectedDoors.length}
								numUsers={this.props.users.length + this.props.usersByInvitation.length}
							/>
                            <h3 className={styles.title}>{ strings('giveVRSelectPermTitle') }</h3>
                            <p className={styles.subtitle}>{ strings('giveVRSelectPermSubtitle') }</p>
                        </div>
                        <CloseIcon className={styles.closeIcon} size="22" onClick={this.state.closePermissions} />
                    </div>
					
					<div className={styles.permissionCenterContent}>
	                    <div className={styles.permissionDoubleContent}>
	                        <div className={classnames(styles.firstBlock, styles.firstBlockPermissionType)}>		
	                            <div className={styles.permissionTypeContent}>
	                                <h3 className={styles.title}>{ strings('permissionType') }</h3>
	                                <div className={classnames('permissionTypeOptions', styles.permissionTypeOptions)}>
	                                    <Radio.Group
	                                        defaultValue={'owner'}
	                                        onChange={this.onChangeTypeOption}
	                                        value={this.state.permission.roleType}
	                                    >
		                                    <div className='permissionTypeItem'>
												{
													this.state.minPermissionType === 'admin' &&
			                                        <Radio value={'owner'}>
			                                            <div className='permissionTextBlock'>
			                                                <p className='text'>{ strings('owner') }</p>
			                                            </div>
			                                        </Radio>
												}
			                                        <Radio value={'guest'}>
			                                            <div className='permissionTextBlock'>
			                                                <p className='text'>{ strings('guest') }</p>
			                                            </div>
			                                        </Radio>
		                                    </div>
	                                    </Radio.Group>
	                                </div>
	                            </div>

	                            {
									(this.state.permission.roleType === 'guest') &&
	                                this.state.permissionFrequency ?
                                    <div className={styles.permissionFrecuencyContent}>
                                        <h3 className={styles.title}>{ strings('permissionFrequency') }</h3>
                                        <div className={classnames('permissionTypeOptions', styles.permissionTypeOptions)}>
                                            <div className='permissionTypeItem frecuencyTypeItem'>
                                                <div className='inputBox'>
                                                    <img className={styles.icon} src={UnlimitedIcon} alt={ strings('giveVRSelectPermUnlimited') } />
                                                </div>
                                                <div className='permissionTextBlock'>
                                                    <p className='text'>{ strings('giveVRSelectPermUnlimited') }</p>
                                                    <Switch
                                                        className='switcher'
                                                        onClick={ () => this.permissionDurationType("unlimited") }
                                                        checked={ (this.state.permissionFrequency === 'unlimited' ) ? true : false}
                                                    />
                                                </div>
                                            </div>
                                            <div className='permissionTypeItem frecuencyTypeItem'>
                                                <div className='inputBox'>
                                                    <img className={styles.icon} src={TemporalIcon} alt={ strings('giveVRSelectPermTemporary') } />
                                                </div>
                                                <div className='permissionTextBlock'>
                                                    <p className='text'>{ strings('giveVRSelectPermTemporary') }</p>
                                                    <Switch
                                                        className='switcher'
                                                        onClick={ () => this.permissionDurationType("temporary") }
                                                        checked={ (this.state.permissionFrequency === 'temporary' ) ? true : false}
                                                    />
                                                </div>
                                            </div>
                                            <div className='permissionTypeItem frecuencyTypeItem'>
                                                <div className='inputBox'>
                                                    <img className={styles.icon} src={RecurrentIcon} alt={ strings('giveVRSelectPermRecurrent') } />
                                                </div>
                                                <div className='permissionTextBlock'>
                                                    <p className='text'>{ strings('giveVRSelectPermRecurrent') }</p>
                                                    <Switch
                                                        className='switcher'
                                                        onClick={ () => this.permissionDurationType("recurrent") }
                                                        checked={ (this.state.permissionFrequency === 'recurrent' ) ? true : false}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
	                                :
	                                null
	                            }
								
								{
									((this.state.permission.roleType === 'owner') || this.state.permissionFrequency !== 'unlimited') ?
			                        <div className={styles.selectRecurrent}>
			                            {
											(this.state.permission.roleType === 'owner') &&
			                                <>
			                                    <h3 className={styles.title}>{strings('giveExtraVirtualRemotes')}</h3>
			                                    <div className={styles.permissionFrecuencyContent}>
			                                        <Counter
			                                            disabledMin={ (this.state.permission.permissionsToGrant < 1) ? true : false }
			                                            //disabledMax={ (this.state.permission.permissionsToGrant > 9) ? true : false }
			                                            number={this.state.permission.permissionsToGrant}
			                                            action={ (e) => this.permissionCount(e) }
			                                        />
													<div className={styles.smallTextDescription}><code>{ strings('extraRemotesDescription') }</code></div>
			                                    </div>
			                                </>
			                            }
			                            {
											this.state.permissionFrequency &&
			                                <>
			                                    { this.durationRender() }
			                                </>
			                            }
			                        </div>
									: null
								}
	                        </div>
							
							<div className={styles.middleBlock}></div>
							
							{								
		                        <div className={styles.secondBlock}>
									<div className={styles.permissionTypeContent}>
										<div className={styles.stickyTopBlock}>
											<h3 className={styles.title}>{ strings('subscription') }</h3>
											<div className={styles.subtitle}>
												{ `${strings('youNeedATotalOf')} `}
												<b>
													{numRemotesNeeded}
													{` ${(numRemotesNeeded === 1 ? strings('remote') : strings('remotes'))}` }
												</b>.
											</div>
										</div>
										<div className={classnames('permissionTypeOptions', 'subscriptionsView')}>
											{
												this.props.selectedDoors.length > 0 &&
												<HouseSubscriptionsView
													selectedDoors={this.props.selectedDoors}
													minRemotesNeeded={this.getNumRemotesNeeded()}
													onSubscriptionSelected={(sub) => this.setState({ selectedSubscription: sub }, () =>
													{
														if (this.props.onSubscriptionSelected != null)
															this.props.onSubscriptionSelected(sub)
													})}
												/>
											}
										</div>
									</div>
		                        </div>
							}
	                    </div>
					</div>

                    <div className={styles.footerBtnPosition}>
						<PrimaryButton
							text={strings('back')}
							onClick={() => this.props.goBack()}
							white
						/>
						
                        <PrimaryButton
                            text={strings('next')}
                            onClick={() => this.savePermission()}
							disabled={this.state.selectedSubscription == null}
                        />
                    </div>
                </div>
			</div>
		);
	}

    onChangeTypeOption = e => {
        this.setState({
            permission: {
                roleType: e.target.value,
                permissionsToGrant: (e.target.value === 'guest') ? 0 : this.state.permission.permissionsToGrant,
            },
            permissionFrequency: e.target.value !== 'owner' && 'unlimited',
        })
    };

    permissionCount(val)
    {
        this.setState({
            permission: {
                roleType: this.state.permission.roleType,
                permissionsToGrant: this.state.permission.permissionsToGrant += val,
            }
        })
    }

    permissionDurationType(value)
    {
        let newPermissionFrequency = value
        let permission = this.state.permission

        if (newPermissionFrequency === 'temporary')
        {
            if (permission.startDate == null)
                permission.startDate = moment().toISOString()
        }

        if (newPermissionFrequency === 'unlimited')
        {
            permission.startDate = null
            permission.endDate = null
        }

        this.setState({ permissionFrequency: newPermissionFrequency, permission }, () =>
		{
			let firstDay = this.daysOfTheWeek[0]
			this.toggleDay(firstDay.value, firstDay.longName)
		})
    }

    toggleDay(val, name)
    {
        let modal = this.state.modal

        Object.keys(modal.markedDays).forEach((key) => {
            modal.markedDays[key].selected = false
        })

        modal.markedDays[val].selected = true

        modal.selectedDay.name = name
        modal.selectedDay.value = val

        modal.disabledEndHours = modal.disabledEndMinutes = modal.disabledStartHours = modal.disabledStartMinutes = null

        this.setState({ modal })
        this.forceUpdate();
    }

    checkIfDaySelected()
    {
        let days = this.state.modal.markedDays
        return days[1].selected ||
            days[2].selected ||
            days[3].selected ||
            days[4].selected ||
            days[5].selected ||
            days[6].selected ||
            days[0].selected
    }

    checkAllDay()
    {
        let modal = this.state.modal

        modal.markedDays[this.state.modal.selectedDay.value].allDay
            = modal.markedDays[this.state.modal.selectedDay.value].set = !modal.markedDays[this.state.modal.selectedDay.value].set

        modal.markedDays[this.state.modal.selectedDay.value].startTime = modal.markedDays[this.state.modal.selectedDay.value].endTime = null

        this.setState({
            modal
        })
        this.validationDaysReset()
    }

    deleteDay()
    {
        let modal = this.state.modal

        modal.markedDays[modal.selectedDay.value] = {
            set: false,
            selected: false,
            allDay: false,
            startTime: null,
            endTime: null
        }
        modal.selectedDay = {
            value: null,
            name: null
        }

        this.setState({
            modal
        })
        this.forceUpdate();
    }

    disabledHours(time)
    {
        let disabled = []

        if (this.state.modal.disabledEndHours && time === 'end') {
            for (
                let i=0;
                i < this.state.modal.disabledEndHours + (this.state.modal.disabledEndMinutes === 59 ? 1 : 0);
                i++
            ) {
                disabled.push(i)
            }
        }

        else if (time === 'start' &&  this.state.modal.disabledStartHours) {
            for (
                let i = this.state.modal.disabledStartHours + 1;
                i < 24;
                i++
            ) {
                disabled.push(i)
            }
        }

        return disabled
    }

    disabledMinutes(time)
    {
        let disabled = []
		
        if (this.state.modal.disabledStartHours === this.state.modal.disabledEndHours) {
            if (time === 'end' && this.state.modal.disabledEndMinutes) {
                for (
                    let i = 0;
                    i < this.state.modal.disabledEndMinutes + 1;
                    i++
                ) {
                    disabled.push(i)
                }
            }
            else if (time === 'start' && this.state.modal.disabledStartMinutes) {
                for (
                    let i = this.state.modal.disabledStartMinutes;
                    i < 60;
                    i++
                ) {
                    disabled.push(i)
                }
            }

        }

        return disabled
    }

    setDisabled(moment, time)
    {
        let modal = this.state.modal

        let hour = moment ? parseInt(moment.format("HH")) : null
        let min = moment ? parseInt(moment.format("mm")) : null

        if (time === 'start') {
            modal.disabledEndHours = hour
            modal.disabledEndMinutes = min
            modal.markedDays[this.state.modal.selectedDay.value].startTime = (hour * 60) + min

            if (modal.markedDays[this.state.modal.selectedDay.value].startTime
                && modal.markedDays[this.state.modal.selectedDay.value].startTime > modal.markedDays[this.state.modal.selectedDay.value].endTime) {
                modal.markedDays[this.state.modal.selectedDay.value].endTime = null
            }
        } else {
            modal.disabledStartHours = hour
            modal.disabledStartMinutes = min
            modal.markedDays[this.state.modal.selectedDay.value].endTime = (hour * 60) + min

            if (modal.markedDays[this.state.modal.selectedDay.value].endTime
                && modal.markedDays[this.state.modal.selectedDay.value].endTime < modal.markedDays[this.state.modal.selectedDay.value].startTime) {
                modal.markedDays[this.state.modal.selectedDay.value].startTime = null
            }
        }

        modal.markedDays[this.state.modal.selectedDay.value].set = !!(modal.markedDays[this.state.modal.selectedDay.value].endTime && modal.markedDays[this.state.modal.selectedDay.value].startTime)

        this.setState({
            modal
        })
        if (modal.markedDays[this.state.modal.selectedDay.value].endTime && modal.markedDays[this.state.modal.selectedDay.value].startTime) {
            this.validationDaysReset()
        }
        this.forceUpdate();
    }

    setDisabledTemporary(moment, time)
    {
        let permission = this.state.permission

        let hour = moment ? parseInt(moment.format("HH")) : null
        let min = moment ? parseInt(moment.format("mm")) : null

        if (moment != null)
        {
            if (time === 'start') {
                permission.startDate.join(hour, min)
            } else {
                permission.startDate.join(hour, min)
            }
        }

        this.setState({
            permission
        })
    }

    durationRender()
    {
        let duration = this.state.permissionFrequency

        if (duration === 'unlimited')
        {
            return null
        }
        else if (duration === 'temporary')
        {
            return (
                <>
                    <h3 className={styles.title}>{ strings('giveVRSelectPermFreqSettings') }</h3>
                    { this.dateRangePick() }
                </>
            )
        }
        else
        {
            return (
            <>
                <h3 className={styles.title}>{ strings('giveVRSelectPermFreqSettings') }</h3>
                <div className={classnames('permissionTypeOptions', styles.permissionTypeContent, styles.daysPermissions)}>
                    <div className={styles.title}>{ strings('permissionDays') }</div>
                        <div className={styles.daysOfTheWeekContainer}>
                            {
                                this.daysOfTheWeek.map((day, i) =>
                                {
                                    return (
                                        <div key={ i } className='daysOfTheWeek'>
                                            <Button
                                                type={ this.state.modal.markedDays[day.value].selected ? 'primary' : 'default' }
                                                shape="circle"
                                                onClick={ () => this.toggleDay(day.value, day.longName)}
                                            >
                                                <span className={ this.state.modal.markedDays[day.value].set ? 'selected' : null }>
                                                    { day.shortName }
                                                </span>
                                            </Button>
                                            <div className={classnames('dot', { set: this.state.modal.markedDays[day.value].set })} />
                                        </div>)
                                })
                            }
                        </div>

                    	{
                        	this.checkIfDaySelected() ?
                            <div className={styles.permissionDay}>
                                <div className={styles.topDayCard}>
                                    <div className={styles.title}>
                                        { this.state.modal.selectedDay.name }
                                    </div>
                                    {
                                        <a
                                            className={styles.deleteDay}
                                            onClick={ () => this.deleteDay() }
                                        >
                                            { strings('clearDay') }
                                        </a>
                                    }
                                </div>

                                <div className={styles.dayCard}>
                                    <div className={classnames('permissionTextBlock', styles.allDay)}>
                                        <div className='text'>{ strings('allDay') }</div>
                                        <Switch
                                            checked={ this.state.modal.markedDays[this.state.modal.selectedDay.value].allDay }
                                            onChange={ () => this.checkAllDay() }
                                            className='switcher'
                                        />
                                    </div>
									
									{
                                        !this.state.modal.markedDays[this.state.modal.selectedDay.value].allDay ?
                                            <>
												<div className={styles.separator}></div>
											
                                                <div className={styles.fromTo}>
                                                    <div className='fromToContent'>
                                                        <div className={styles.label}>{ strings('from') }</div>
                                                        <TimePicker
                                                            format={timeFormat}
                                                            placeholder={strings('schedule')}
                                                            suffixIcon={ <img src={DownOutlinedIcon} />}
                                                            value={
                                                                this.state.modal.markedDays[this.state.modal.selectedDay.value].startTime ?
                                                                    moment(
                                                                        SelectAccessTypePermissions.getTime(this.state.modal.markedDays[this.state.modal.selectedDay.value].startTime),
                                                                        timeFormat
                                                                    )
                                                                    :
                                                                    null
                                                            }
                                                            disabledHours={ () => this.disabledHours('start') }
                                                            disabledMinutes={ () => this.disabledMinutes('start') }
                                                            onChange={ (e) => this.setDisabled(e, 'start') }
                                                        />
                                                    </div>
                                                    <div className='fromToContent'>
                                                        <div className={styles.label}>{ strings('to') }</div>
                                                        <TimePicker
                                                            format={timeFormat}
                                                            placeholder={strings('schedule')}
                                                            suffixIcon={ <img src={DownOutlinedIcon} /> }
                                                            value={
                                                                this.state.modal.markedDays[this.state.modal.selectedDay.value].endTime ?
                                                                    moment(
                                                                        SelectAccessTypePermissions.getTime(this.state.modal.markedDays[this.state.modal.selectedDay.value].endTime),
                                                                        timeFormat
                                                                    ) :
                                                                    null
                                                            }
                                                            disabledHours={ () => this.disabledHours('end') }
                                                            disabledMinutes={ () => this.disabledMinutes('end') }
                                                            onChange={ (e) => this.setDisabled(e, 'end') }
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                            :
                            null
                    	}
						
	                    <div className='startEndingBlock'>
	                        <div className='starting'>
	                            <div className='title'>{ strings('starting') }</div>
	                                <DatePicker
	                                    format={ dateDisplayFormat }
	                                    value={
	                                        this.state.permission.startDate ?
	                                            moment(this.state.permission.startDate, dateFormat)
	                                            :
	                                            null
	                                    }
	                                    placeholder={ strings('selectStartingDate') }
	                                    onChange={ e => this.onDateChange('startDate', e) }
	                                />
	                        </div>
	                        <div className='ending'>
	                            <div className='title'>{ strings('ending') }</div>
	                                <DatePicker
	                                    format={dateDisplayFormat}
	                                    value={
	                                        this.state.permission.endDate ?
	                                            moment(this.state.permission.endDate, dateFormat)
	                                            :
	                                            null
	                                    }
	                                    placeholder={ strings('selectEndingDate') }
	                                    onChange={ e => this.onDateChange('endDate', e) }
	                                />
	                        </div>
	                    </div>
                	</div>
            </>)
        }
    }

    onDateChange = (field, value) =>
    {
        let permission = this.state.permission

        if (value != null)
        {
            permission[field] = value.toISOString(true)

            if (permission.endDate &&
                permission.startDate &&
                (moment(permission.endDate).diff(moment(permission.startDate), 'days') < 0))
            {
                if (field === 'startDate')
                    permission.endDate = null
                else
                    permission.startDate = null
            }
        }
        else
        {
            permission[field] = value;
        }
        this.setState({ permission })
        this.forceUpdate();
    }

    static getTime(val)
    {
        return `${val/60} : ${val%60}`
    }

    calendarChange(days)
    {
        let permission = this.state.permission

        permission.startDate    = days[0] ? days[0].toISOString() : null
        permission.endDate      = days[1] ? days[1].toISOString() : null

        this.setState({ permission })
    }

    dateRangePick()
    {
        return (
            <div className={ classnames(styles.permissionTypeContent, styles.temporaryPermission) }>
                <div className='permissionTypeOptions startEndingBlock'>
                    <div className='starting'>
                        <div className='title'>{ strings('from') }</div>
                            <DatePicker
                                format={dateTimeDisplayFormat}
                                showTime={{ format: 'HH:mm' }}
                                value={
                                    this.state.permission.startDate ?
                                        moment(this.state.permission.startDate)
                                        :
                                        null
                                }
                                placeholder={ strings('selectStartingDate') }
                                onChange={ e => this.onDateChange('startDate', e) }
                            />
                    </div>
                    <div className='ending'>
                        <div className='title'>{ strings('to') }</div>
                            <DatePicker
                                format={dateTimeDisplayFormat}
                                showTime={{ format: 'HH:mm' }}
                                value={
                                    this.state.permission.endDate ?
                                        moment(this.state.permission.endDate)
                                        :
                                        null
                                }
                                placeholder={ strings('selectEndingDate') }
                                onChange={ e => this.onDateChange('endDate', e) }
                            />
                    </div>
                </div>
            </div>
        )
    }

    validationReset()
    {
        this.setState({
            validation: {
                state: '',
                message: ''
            }
        })
    }

    validationDaysReset()
    {
        this.setState({
            validationDays: {
                state: '',
                message: ''
            }
        })
    }

    validation(permission)
    {
        if (permission.roleType === 'guest')
        {

            if (this.state.permissionFrequency === 'temporary' && (!permission.startDate || !permission.endDate))
			{
				notification.error(
				{
					message: 'Elige un rango válido de fechas',
					placement: 'top'
				})
				
                this.setState({
                    validation: {
                        state: 'error',
                        message: 'Select date range'
                    }
                })
                return false
            }

            if (this.state.permissionFrequency === 'recurrent' && !permission.startDate)
			{
				notification.error(
				{
					message: 'Elige una fecha de inicio válida',
					placement: 'top'
				})
				
                this.setState({
                    validation: {
                        state: 'error',
                        message: 'Select start date'
                    }
                })
                return false
            }

            if (this.state.permissionFrequency === 'recurrent' && !this.checkSelectedDays())
			{
				notification.error(
				{
					message: 'Elige un día y selecciona todo el día o un tiempo de inicio y de fin.',
					placement: 'top'
				})
				
                this.setState({
                    validationDays: {
                        state: 'error',
                        message: 'Select a day and set start, end times or check all day'
                    }
                })
                return false
            }
        }

        return true
    }

    checkSelectedDays()
    {
        let modal = this.state.modal
        
		let allOk = Object.keys(modal.markedDays).some(i =>
        {
			let day = modal.markedDays[i]
            return (day.set && (day.allDay || (day.startTime != null && day.endTime != null)))
        })

        return allOk
    }

    savePermission()
    {
        let modal = this.state.modal
        let permission = {...this.state.permission}

        // delete permission.PermissionDays

        if (permission.roleType === 'guest')
        {
            permission.permissionsToGrant = 0;
            permission.frequency = this.state.permissionFrequency;

            if (this.state.permissionFrequency === 'recurrent')
            {
                permission.permissionDays = []

                Object.keys(modal.markedDays).forEach(i =>
                {
                    if (modal.markedDays[i].set)
                    {
                        permission.permissionDays.push(
                            {
                                dayOfWeek: parseInt(i),
                                startTime: modal.markedDays[i].startTime,
                                endTime: modal.markedDays[i].endTime
                            })
                    }
                })
            }
                else if (this.state.permissionFrequency === 'temporary')
            {
                permission.startDate = this.state.permission.startDate;
                permission.endDate = this.state.permission.endDate;
            }
        }

        this.confirmPermission(permission)
    }

	validateUserHasEnoughVRs()
	{
		// Only check VRs if owner and has extra remotes, to recalculate how many VRs are needed per door
		if (this.state.permission.roleType != 'owner' || this.state.permission.permissionsToGrant === 0)
			return true
		
		let userHasEnoughVRs = true
		let totalVRsNeededPerDoor = (this.props.users.length + this.props.usersByInvitation.length) +
									(this.props.users.length + this.props.usersByInvitation.length)*this.state.permission.permissionsToGrant
		
		for (let i = 0; i < this.props.selectedDoors.length && userHasEnoughVRs; i++)
		{
			let d = this.props.selectedDoors[i]
			console.log(d.myPermission)
			let freeVRs = d.myPermission?.virtualRemotes?.filter(vr => !vr.assignedUserId && !vr.reserved)
			if (freeVRs.length < totalVRsNeededPerDoor)
				userHasEnoughVRs = false
		}
		
		if (!userHasEnoughVRs)
		{
			notification.error(
			{
				message: 'No tienes suficientes Mandos Virtuales',
				description : <code>Necesitas <b>{totalVRsNeededPerDoor} Mandos Virtuales</b> disponibles por puerta. Elimina primero algún permiso o adquiere más Mandos Virtuales.</code>,
				placement: 'top'
			})
		}
		
		return userHasEnoughVRs
	}

    confirmPermission(permission)
    {
		if (this.validation(permission)/* && this.validateUserHasEnoughVRs()*/)
        	this.props.confirmPermission(permission)
    }
	
	getNumRemotesNeeded()
	{
		// (Num users to invite) x (1 VR per user + extra remotes)
		return (this.props.users.length + this.props.usersByInvitation.length) * (1 + this.state.permission.permissionsToGrant)
	}
	
	setMinPermissionType()
	{
		let minPermissionType = 'admin'
		let selectedDoors = this.props.selectedDoors
		
		for (let i = 0; i < selectedDoors.length; i++)
		{
			let roleType = selectedDoors[i].roleType
			
			if (minPermissionType === 'admin')
			{
				if (roleType != 'admin')
					minPermissionType = roleType
			}
			else if (minPermissionType === 'owner')
			{
				if (roleType === 'guest')
					minPermissionType = roleType
			}
		}
		
		this.setState({ minPermissionType })
	}
}
